import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Banner from './Banner';

const asArray = (v) => (Array.isArray(v) ? v : []);

const ServiceDetailTemplate = ({ moduleKey, bnrimg, productImg }) => {
    const { t } = useTranslation();
    const [openFaq, setOpenFaq] = useState(0);
    const KEY = `pages.servicesDetail.${moduleKey}`;

    // Carga custom.js (Stellar) para activar el parallax del banner —igual que
    // el resto de páginas (About, Protección de Datos, etc.). Sin esto el
    // banner de servicios queda estático.
    useEffect(() => {
        const script = document.createElement('script');
        script.src = './assets/js/custom.js';
        script.async = true;
        document.body.appendChild(script);
        return () => { try { document.body.removeChild(script); } catch (e) { /* ya removido */ } };
    }, []);

    const features = asArray(t(`${KEY}.features`, { returnObjects: true }));
    const faq = asArray(t(`${KEY}.faq`, { returnObjects: true }));
    const ctaCards = asArray(t(`${KEY}.ctaCards`, { returnObjects: true }));

    return (
        <>
            <Header />
            <div className="page-content">
                <Banner
                    title={t(`${KEY}.banner.title`)}
                    pagename={t(`${KEY}.banner.pagename`)}
                    description={t(`${KEY}.banner.description`)}
                    bgimage={bnrimg}
                />

                {/* Intro — captura del módulo + texto */}
                <div className="svc-section svc-cream mobile-page-padding">
                    <div className="container">
                        <div className="svc-intro-grid">
                            {productImg && (
                                <div className="svc-media">
                                    <img src={productImg} alt={t(`${KEY}.banner.title`)} />
                                </div>
                            )}
                            <div className="svc-intro-content">
                                <p className="svc-eyebrow">{t(`${KEY}.banner.pagename`)}</p>
                                <h2 className="svc-title">{t(`${KEY}.intro.title`)}</h2>
                                <div className="svc-rule" />
                                <p className="svc-text">{t(`${KEY}.intro.body`)}</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Características */}
                {features.length > 0 && (
                    <div className="svc-section svc-white mobile-page-padding">
                        <div className="container">
                            <div className="svc-head-center">
                                <h2 className="svc-title">{t(`${KEY}.featuresTitle`)}</h2>
                                <div className="svc-rule" />
                            </div>
                            <div className="svc-features">
                                {features.map((f, i) => (
                                    <div className="svc-feature" key={i}><span>{f}</span></div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                {/* FAQ */}
                {faq.length > 0 && (
                    <div className="svc-section svc-cream mobile-page-padding">
                        <div className="container">
                            <div className="svc-head-center">
                                <h2 className="svc-title">FAQ</h2>
                                <div className="svc-rule" />
                            </div>
                            <div className="svc-faq">
                                {faq.map((item, idx) => {
                                    const isOpen = openFaq === idx;
                                    return (
                                        <div className="svc-faq-item" key={idx}>
                                            <button
                                                type="button"
                                                className="svc-faq-q"
                                                aria-expanded={isOpen}
                                                onClick={() => setOpenFaq(isOpen ? -1 : idx)}
                                            >
                                                {item.q}
                                                <span className="ind">{isOpen ? '−' : '+'}</span>
                                            </button>
                                            {isOpen && (
                                                <div className="svc-faq-a">
                                                    <p>{item.a}</p>
                                                    {item.to && (
                                                        <div style={{ marginTop: '14px' }}>
                                                            <NavLink to={item.to} className="svc-card-link">
                                                                {item.linkLabel}
                                                                <span className="arw">&rarr;</span>
                                                            </NavLink>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                )}

                {/* Tarjetas CTA */}
                {ctaCards.length > 0 && (
                    <div className="svc-section svc-white mobile-page-padding">
                        <div className="container">
                            <div className="svc-cta-grid">
                                {ctaCards.map((c, idx) => (
                                    <div className="svc-card" key={idx}>
                                        {c.icon && <i className={`${c.icon} svc-card-ic`} />}
                                        <h4>{c.title}</h4>
                                        <p>{c.body}</p>
                                        <NavLink to={c.to} className="svc-card-link">
                                            {c.linkLabel}
                                            <span className="arw">&rarr;</span>
                                        </NavLink>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <Footer />
        </>
    );
};

export default ServiceDetailTemplate;
